import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'antd';

import selector from './closingEditor.selector';
import {
  setSelected,
  setUiOpenSection,
  setUiScrollTarget
} from '../Construction/construction.reducer';

import SelectEdit from '../../components/SelectEdit';

import { availableType } from '../../types/available.types';
import { infoShape } from '../../types/info.types';

class ClosingEditor extends React.Component {
  static propTypes = {
    loaded: PropTypes.bool.isRequired,
    setSelected: PropTypes.func.isRequired,
    setUiOpenSection: PropTypes.func.isRequired,
    setUiScrollTarget: PropTypes.func.isRequired,
    available: PropTypes.arrayOf(availableType),
    info: infoShape,
    selected: PropTypes.number,
    translationsData: PropTypes.object
  };

  static defaultProps = {
    available: [],
    selected: null,
    info: null,
    translationsData: {}
  };

  performClosingAction = (chosenValue) => {
    return true;
  };

  openTranslatedConfirmModal = (nextValue) => {
    const { translationsData } = this.props;
    console.log(translationsData);
    const title = translationsData.closing_modal_title || 'closing_modal_title';
    const html = translationsData.closing_modal_content || 'closing_modal_content';

    Modal.confirm({
      title,
      okText: translationsData.remote_add_doors || 'remote_add_doors',
      cancelText: translationsData.close_modal || 'close_modal',
      content: html ? (
        // eslint-disable-next-line react/no-danger
        <div dangerouslySetInnerHTML={{ __html: html }} />
      ) : null,

      onOk: () => {
        return Promise.resolve(this.performClosingAction(nextValue)).then(() => {
          // ✅ otwórz ConstructionExtras + drzwi i ustaw cel scrolla
          this.props.setUiOpenSection('constructionExtras', true);
          this.props.setUiOpenSection('doors', true);
          this.props.setUiScrollTarget('doorsEditor');
        });
      },

      onCancel: () => {}
    });
  };

  handleWidthChange = (value) => {
    const next = Number(value);
    const prev = Number(this.props.selected);

    // zawsze ustawiamy wybraną wartość
    this.props.setSelected('closing', value);

    // jeśli wybrano opcję 2, to modal
    if (next === 2 && prev !== 2) {
      this.openTranslatedConfirmModal(value);
    }
  };

  render() {
    const { loaded, selected, info, available } = this.props;

    return loaded ? (
      <SelectEdit
        selected={selected}
        loaded={loaded}
        title={info?.name}
        info={info}
        onChange={this.handleWidthChange}
        options={available.map((el) => ({
          id: el.id,
          value: `${el.attributes.value}`
        }))}
      />
    ) : (
      <SelectEdit loading />
    );
  }
}

const mapDispatchToProps = {
  setSelected,
  setUiOpenSection,
  setUiScrollTarget
};

export default connect(selector, mapDispatchToProps)(ClosingEditor);
